import { Link } from "react-router-dom";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";

const CompanyIntro = () => {
  const features = [
    "Residential & Commercial Construction",
    "Property Development Solutions",
    "Property Buying & Selling Services",
    "Government Liaisoning & Documentation",
  ];

  return (
    <section className="py-12 md:py-24 bg-white overflow-hidden">
      <div className="container-custom">

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">

          {/* Left Image */}

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src="assets/images/company-intro.png"
              alt="AZ Construction"
              className="rounded-3xl shadow-xl w-full h-auto object-cover"
            />

            {/* Floating Card */}

            <div className="relative mt-6 md:mt-0 md:absolute md:-bottom-6 md:-left-6 lg:bottom-6 lg:-left-6 bg-[#082B57] rounded-2xl p-6 shadow-2xl z-10 w-full md:w-auto text-center md:text-left">
              <h3 className="text-4xl md:text-5xl font-bold text-[#F59E0B]">
                10+
              </h3>

              <p className="text-white mt-2 font-medium">
                Years Of Experience
              </p>
            </div>
          </motion.div>

          {/* Right Content */}

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >

            <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
              Who We Are
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4 leading-tight">
              Trusted Construction &
              <span className="text-[#F59E0B]">
                {" "}Development Partner
              </span>
            </h2>

            <p className="text-gray-600 leading-8 mt-8">
              AZ Construction is a trusted name in construction,
              development, property consultancy and liaisoning
              services. We are dedicated to delivering quality
              projects that create long-term value for our clients
              and communities.
            </p>

            <p className="text-gray-600 leading-8 mt-4">
              With years of industry experience, our team combines
              technical expertise, innovative thinking and a
              customer-first approach to ensure every project is
              completed with excellence, transparency and
              professionalism.
            </p>

            {/* Features */}

            <div className="grid sm:grid-cols-2 gap-4 mt-10">

              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3"
                >
                  <FaCheckCircle className="text-[#F59E0B] mt-1" />

                  <span className="text-gray-700">
                    {item}
                  </span>
                </div>
              ))}

            </div>

            {/* Buttons */}

            <div className="flex flex-col sm:flex-row gap-4 mt-10 max-w-md sm:max-w-none">

              <Link
                to="/services"
                className="w-full sm:w-auto bg-[#F59E0B] hover:bg-orange-600 text-white px-8 py-4 rounded-xl font-semibold transition flex items-center justify-center gap-2"
              >
                Our Services
                <FaArrowRight />
              </Link>

              <Link
                to="/contact-us"
                className="w-full sm:w-auto border-2 border-[#082B57] text-[#082B57] hover:bg-[#082B57] hover:text-white transition px-8 py-4 rounded-xl font-semibold flex items-center justify-center"
              >
                Contact Us
              </Link>

            </div>

          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default CompanyIntro;